import React from 'react';
import PropTypes from 'prop-types';

const FormGroup = (props) => (
  <div className={`form-group ${props.className == null ? '' : props.className}`}>{props.children}</div>
);

FormGroup.propTypes = {
  className: PropTypes.string,
};

export default FormGroup;
